import { useDispatch, useSelector } from 'react-redux'

import { apiGetAccount } from 'api/adcritterApi'
import { CampaignApprovalQueueItem } from 'api/interfaces'
import { showErrorToast, updateAccountState } from 'app/appSlice'
import { RootState } from 'app/rootReducer'
import { approvalQueuePath, pushWithReturnTo } from 'hooks/useBackNavigation'

export const useOpenFromApprovalQueue = () => {
  const dispatch = useDispatch()
  const { currentAccount } = useSelector((state: RootState) => state.app)

  const openPath = async (accountId: string, path: string) => {
    if (currentAccount?.id !== accountId) {
      try {
        const response = await apiGetAccount(accountId)
        dispatch(updateAccountState(response.data))
      } catch {
        dispatch(showErrorToast('Could not switch to the campaign account'))
        return
      }
    }

    pushWithReturnTo(path, approvalQueuePath)
  }

  const openCampaign = (item: CampaignApprovalQueueItem) => openPath(item.accountId, `/campaigns/edit/${item.campaignId}`)

  const openAd = (item: CampaignApprovalQueueItem, adId: string) => openPath(item.accountId, `/campaigns/ads/${item.campaignId}/edit/${adId}`)

  return { openCampaign, openAd }
}
